import { createSlice } from '@reduxjs/toolkit';
import { v4 as uuidv4 } from 'uuid';

let mockupLdapServer = {
  jsonrpc: '2.0',
  id: '9f496b25-47c6-414d-8505-9fb7140427bc',
  data: [
    {
      id: '001',
      name: 'HQ_ActiveDirectory',
      server: '192.168.10.20',
      port: 389,
      authMode: 'Simple',
      username: 'ldap_admin',
      password: 'password123',
      baseDN: 'dc=example,dc=com',
      accountAttr: 'sAMAccountName',
      identity: 'memberOf=cn=it_department',
      autoCopy: true,
    },
    {
      id: '002',
      name: 'Taipei_Branch_LDAP',
      server: '192.168.10.25',
      port: 636,
      authMode: 'Simple',
      username: 'aaa_admin',
      password: 'password123',
      baseDN: 'dc=example,dc=com',
      accountAttr: 'sAMAccountName',
      identity: 'CN=ldap_admin',
      autoCopy: true,
    },
    {
      id: '003',
      name: 'Google_Cloud_Identity',
      server: '192.168.10.102',
      port: 3269,
      authMode: 'TLS',
      username: 'bbb_admin',
      password: 'password123',
      baseDN: 'dc=example,dc=com',
      accountAttr: 'sAMAccountName',
      identity: 'OU=Users',
      autoCopy: false,
    },
    {
      id: '004',
      name: 'Staging_OpenLDAP',
      server: '10.0.30.55',
      port: 389,
      authMode: 'TLS',
      username: 'ccc_admin',
      password: 'password123',
      baseDN: 'dc=example,dc=com',
      accountAttr: 'sAMAccountName',
      identity: 'DC=example,DC=com',
      autoCopy: false,
    },
  ],
};

export const ldapServerSlice = createSlice({
  name: 'profilesLdapServer',
  initialState: mockupLdapServer,
  reducers: {
    createProfilesLdapServer: (state, action) => {
      const newLdap = { ...action.payload, id: uuidv4() }; // fake id.
      if (action?.payload) state.data = [...state.data, structuredClone(newLdap)];
    },
    updateProfilesLdapServer: (state, action) => {
      if (action?.payload) {
        const index = state.data.findIndex(ldap => ldap.id === action.payload.id);

        if (index !== -1) {
          state.data[index] = structuredClone(action.payload);
        }
      }
    },
    deleteProfilesLdapServer: (state, action) => {
      if (action?.payload?.ids) {
        const remainLdapList = state.data.filter(ldap => !action.payload.ids.includes(ldap.id));
        state.data = remainLdapList;
      }
    },
  },
});

export const { createProfilesLdapServer, updateProfilesLdapServer, deleteProfilesLdapServer } = ldapServerSlice.actions;

export default ldapServerSlice.reducer;
